import React, { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./ToastComponent.scss";
import WarningIcon from '../../images/gilead-warning.svg';
import {ReactComponent as FailedIcon} from '../../images/FAILED.svg';

// Custom success toast
export const showSuccessToast = (message, btnMessage="OK, GOT IT", toastImage, closeTime=3000) => {
  
  const toastMessage = toast.success(
    <div className='custom-toast-message'>
      <div className='d-flex'>
        <img src={WarningIcon} alt="" />
        <h4>{message}</h4>
      </div>
      <button className='toast-button' onClick={() => toast.dismiss(toastMessage)}>{btnMessage}</button>
    </div>, {
    className: 'custom-toast success-toast',
    bodyClassName: 'custom-toast-body',
    progressClassName: 'custom-toast-progress',
    // autoClose: false,
    closeOnClick: false,
    closeButton: false,
    autoClose: closeTime,
    hideProgressBar: true,
    pauseOnHover: false,
    draggable: false
  });
  
  return toastMessage;
};

// Custom error toast
export const showErrorToast = (message, textMessage, toastImage, toastId) => {
  const toastMessage = toast.error(
    <div className='custom-toast-message'>
      <div className='d-flex'>
        <FailedIcon className='toast-icon error-toast-icon'/>
        {/* {!toastImage && <img src={FailedIcon} alt="" />} */}
        <div>
          <h4>{message}</h4>
          {textMessage && <h2>{textMessage}</h2>}
        </div>
      </div>
      <button className='toast-button' onClick={() => toast.dismiss(toastMessage)}>OK, GOT IT</button>
    </div>, {
    toastId: toastId,
    className: 'custom-toast error-toast',
    bodyClassName: 'custom-toast-body',
    progressClassName: 'custom-toast-progress',
    // autoClose: false,
    closeOnClick: false,
    closeButton: false,
    autoClose: 3000,
    hideProgressBar: true,
    pauseOnHover: false,
    draggable: false
  });
  
  return toastMessage;
};

export const showWarningToast = (message, headerMessage) => {
  
  const toastMessage = toast.warning(
    <div className='custom-toast-warning-message'>
      <div className='d-flex align-items-center'>
        <img src={WarningIcon} alt="" />
        <div>
          {headerMessage && <h2>{headerMessage}</h2>}
          <h4  style={{padding: "0"}}>{message}</h4>
        </div>
      </div>
      <button className='toast-button' onClick={() => toast.dismiss(toastMessage)}>OK, GOT IT</button>
    </div>, {
    className: 'custom-toast success-toast',
    bodyClassName: 'custom-toast-body',
    progressClassName: 'custom-toast-progress',
    // autoClose: false,
    closeOnClick: false,
    closeButton: false,
    autoClose: 3000,
    hideProgressBar: true,
    pauseOnHover: false,
    draggable: false
  });
  
  return toastMessage;
};

export const showChildrenPropsToast = (children) => {
  
  const toastMessage = toast.warning(
    <div className='custom-toast-warning-message'>
      <div className='d-flex'>
        <img src={WarningIcon} alt="" />
        <div>
          {children}
        </div>
      </div>
      <button className='toast-button' onClick={() => toast.dismiss(toastMessage)}>OK, GOT IT</button>
    </div>, {
    className: 'custom-toast success-toast',
    bodyClassName: 'custom-toast-body',
    progressClassName: 'custom-toast-progress',
    // autoClose: false,
    closeOnClick: false,
    closeButton: false,
    autoClose: 3000,
    hideProgressBar: true,
    pauseOnHover: false,
    draggable: false
  });
  
  return toastMessage;
};

export const SuccessToastComponent = (props) => {
    return (
        toast.success(
            <div className="mlrSubmissionStatusMsg">
              <p className="mlr-submission-header">MLR Submission Successful</p>
            </div>,
            {
              position: "top-right",
              autoClose: 3000,
            //   icon: (
            //     <img className="toast-mlr-success-icon" src={SuccessIcon} />
            //   ),
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
            //   closeButton: (
            //     <img className="toast-mlr-success-close-icon" src={CloseIcon} />
            //   ),
              progress: undefined,
              className: "toast-popup toast-success-popup",
            }
        )
    )
}

export const ErrorToastComponent = (props) => {
    return (
    toast.error(
        <div className="toast-text-message">
            MLR Submission failed. Pl try again
        </div>,
        {
            position: "top-right",
            autoClose: 150000,
            // icon: <img className="toast-delete-error-icon" src={ErrorIcon} />,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            // closeButton: (
            // <img className="toast-error-close-icon" src={CloseIcon} />
            // ),
            progress: undefined,
            className: "toast-popup toast-error-popup",
        }
        )
    )
}